import styled from 'styled-components'

import { Button as GenericButton } from '@syconium/little-miss-figgy'

export const Button = styled(GenericButton)`
  padding: 12px;
  letter-spacing: 0.6px;
`

export const IconWrapper = styled.span`
  margin-top: 0;
  margin-bottom: -5px;
  margin-inline-start: 0;
  margin-inline-end: 10px;
`
